import React from 'react'
import { AppTransmissionAutocomplete } from '@components'
import { BACKEND_APIS } from '@constants'
import { useAppFormHandler } from '@hooks'


export default function TransmissionSelector() {

	const { automatic, onAutomaticChange } = useAppFormHandler('automatic')

	return <AppTransmissionAutocomplete
		value={automatic}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/transmission`}
		onChange={e => onAutomaticChange(e.target.value)}
	/>
}